import { useContext, useState } from 'react';
import './ComputeChange.css';
import './receipt.css';
import { formatDollars } from '../../shared/functions/formatter';
import { Button } from '../../ui';
import { CashierContext } from '../Cashier';

const denominations = [50, 10, 5, 2, 1, 0.5];

const ComputeChange = () => {
  const {
    state: { items, total },
  } = useContext(CashierContext);
  const [received, setReceived] = useState(0);
  return (
    <div className="computeChangeContainer">
      <div className="denseTable">
        <table>
          <thead>
            <tr>
              <th>S/N</th>
              <th align="left">Name</th>
              <th>Price</th>
              <th>Qty</th>
              <th>Subtotal</th>
            </tr>
          </thead>
          <tbody>
            {items.map(({ title, quantity, price, subtotal }, idx) => (
              <tr key={idx}>
                <td>{idx + 1}</td>
                <td align="left">{title}</td>
                <td align="right" className="money">
                  <div>{formatDollars(price)}</div>
                </td>
                <td>{quantity}</td>
                <td align="right" className="money">
                  {' '}
                  <div>{formatDollars(subtotal)}</div>
                </td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td />
              <td colSpan={2} align="right">
                Total:
              </td>
              <td colSpan={2} className="money">
                ({formatDollars(total)})
              </td>
            </tr>
            <tr className="cashReceivedRow">
              <td />
              <td colSpan={2} align="right">
                Cash Received:
              </td>
              <td colSpan={2} className="cashReceived money">
                {formatDollars(received)}
              </td>
            </tr>
            <tr>
              <td />
              <td colSpan={2} align="right">
                Balance:
              </td>
              <td colSpan={2} className="money">
                {received - total < 0 ? `(${formatDollars(total - received)})` : formatDollars(received - total)}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div className="denomsGrid">
        {denominations.map((val, idx) => (
          <div key={idx} className="notesAdder">
            <Button className="denomButton" onClick={() => setReceived(received - val)}>
              -
            </Button>
            {formatDollars(val)}
            <Button className="denomButton" onClick={() => setReceived(received + val)}>
              +
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ComputeChange;
